import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { SpecificGravityService } from 'pages/system-fields/specific-gravities/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(SpecificGravityService, DialogService, EventAggregator)
export class SpecificGravities {
    constructor(specificGravityService, dialogService, ea) {
        this.ea = ea;
        this.specificGravityService = specificGravityService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'coatingName', sortOrder: 'asc', caption: 'Coating', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'thicknesses', encodeHtml: false, allowSorting: false, allowFiltering: false },
            { dataField: 'gravities', encodeHtml: false, allowSorting: false, allowFiltering: false },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('specific-gravities:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (specificGravity) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.specificGravityService.delete(specificGravity.id);
                this.grid.refresh();
                toastr.success('Specific gravity was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.specificGravityService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.specificGravityService.editor, model: { id: data.id } });
    };
}